import '@Pages/GeoMMM/ScenarioPlanning/ScenarioPlanningPresets.scss';
import { ReactElement } from 'react';
import {
  ScenarioPlanningPreset,
  ScenarioPresetKey
} from '@Pages/GeoMMM/ScenarioPlanning/useScenarioPlanningPresets';

interface ScenarioPlanningPresetsProps {
  presets: ScenarioPlanningPreset[];
  selectedKey?: ScenarioPresetKey;
  onSelect: (preset: ScenarioPlanningPreset) => void;
}

export const ScenarioPlanningPresets = ({
  presets,
  selectedKey,
  onSelect
}: ScenarioPlanningPresetsProps): ReactElement => (
  <div className='scenario-planning-presets'>
    <div className='presets-title'>Presets</div>
    <div className='presets-list'>
      {presets.map(preset => (
        <button
          key={preset.key}
          type='button'
          className={`preset-item${selectedKey === preset.key ? ' selected' : ''}`}
          onClick={() => onSelect(preset)}
          disabled={preset.disabled}
        >
          <div className='preset-label'>{preset.label}</div>
          <div className='preset-sublabel'>{preset.sublabel}</div>
        </button>
      ))}
    </div>
  </div>
);
